import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const paymentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCustomer: builder.mutation({
      query: ({stripeToken}) => ({
        url: 'customer/',
        method: 'POST',
        body: {stripe_token: stripeToken},
      }),
      invalidatesTags: ['Customer'],
    }),
    getCards: builder.query({
      query: ({} = {}) => ({
        url: '/customer',
        method: 'GET',
      }),
      providesTags: ['Customer'],
    }),
    updateCard: builder.mutation({
      query: ({stripe_token}) => ({
        url: 'customer/',
        method: 'PUT',
        body: {stripe_token},
      }),
      invalidatesTags: ['Customer'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateCustomerMutation,
  useGetCardsQuery,
  useUpdateCardMutation,
} = paymentApi;
